import { all_roles } from '@/utils';
import { Polls } from '@/modules/polls/types';

const access_roles = {
  [Polls.Pages.POLL]: all_roles,
};

export default access_roles;
